import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { HlookupsModalEditComponent } from './hlookups-modal-edit/hlookups-modal-edit.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-hlookups',
  templateUrl: './hlookups.component.html',
  styleUrls: ['./hlookups.component.scss']
})
export class HlookupsComponent implements OnInit {

  gridApi: GridApi;
  columnDefs;
  operations;
  rowData;
  advanceSearch;
  selectedRow;
  orgForm: UntypedFormGroup;
  modules: any;
  collapesedOrNot: boolean;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal
  ) {

  }

  ngOnInit() {

    this.orgForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      MODULEID: new UntypedFormControl("")
    });

    this.columnDefs = [
      // {
      //   "headerName": "Code",
      //   "field": "CODE",
      //   "sort": "asc"

      // },
      {
        "headerName": "Name",
        "field": "NAME",
      },
      {
        "headerName": "Program Name",
        "field": "MODULENAME",
      }
    ];

    this.advanceSearch = {
      "fields": [
        {
          "label": "Code",
          "field": "Code",
          "type": "text"
        },
        {
          "label": "Name",
          "field": "Name",
          "type": "text"
        }
      ]
    };

    this.operations = [
      {
        "name": "Edit",
        "id": "edit"
      }
    ];

    this.operations = this.operations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    this.getModules();
  }

  getModules() {
    this.orgForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      MODULEID: new UntypedFormControl("")
    });
   this.summaryService.getModuleByOrgId('api/common/getmodulesbyid').subscribe((result) => {
     this.modules = result;
     // this.setSearchSummary(this.orgForm.value);
   });

    this.setSummary();
  }

  setSummary() {
    this.summaryService.getHLookupsSummary().subscribe(summary => {
      this.rowData = summary;
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    debugger;
   if(!this.modalService.hasOpenModals())
   {
    const modelRef= this.modalService.open(HlookupsModalEditComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content={
      heading: 'Edit',
        id: this.selectedRow['CODE'], Name: this.selectedRow['NAME'], Module: this.selectedRow['MODULEID'],Modulecode:this.selectedRow['MODULENAME']}
   }
  }

  edit() {
    debugger;
    let modalRef = this['self'].modalService.open(HlookupsModalEditComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content={
        heading: 'Edit',
          id: this['self'].selectedRow['CODE'],
           Name: this['self'].selectedRow['NAME'],
            Module: this['self'].selectedRow['MODULEID'],
            Modulecode:this['self'].selectedRow['MODULENAME']
      }
 
    modalRef.result.then(result=>{
      this['self'].setSummary();
    })
  }

  add() {
    //this['self'].modalService.show(LookupsAddMultipleComponent, {
    //  backdrop: false,
    //  keyboard: false,
    //  ignoreBackdropClick: true,
    //  class: 'modal-lg modal-full-height modal-right',
    //  animated: true
    //});
  }
  
  sort_order(){
   
  }

  setSearch() {
    this.SearchClear();
    this.summaryService.getHLookupsAdvSearch(this.orgForm.value).subscribe(summary => {
      this.rowData = summary;
    });
  }

  setSearchSummary(formData) {
    this.summaryService.getHLookupsAdvSearch(formData).subscribe(summary => {
      this.rowData = summary;
    });
  }


  //// Advace search Functions
  SearchClear() {
    this.orgForm.reset();
   
    //  this.setSummary();
  }

  AdvanceSearch() {
    this.setSearchSummary(this.orgForm.value);
  }
}
